import { RecentlyViewed } from './recently-viewed-products.js';

class FigmaRecentlyViewed extends HTMLElement {
  connectedCallback() {
    this.#loadRecentlyViewed();
  }

  /**
   * Load and display recently viewed products
   */
  async #loadRecentlyViewed() {
    const currentProductId = this.dataset.productId;
    const maxProducts = parseInt(this.dataset.maxProducts) || 4;

    // Get recently viewed product IDs from localStorage
    const viewedProductIds = RecentlyViewed.getProducts()
      .filter(id => id !== currentProductId) // Exclude current product
      .slice(0, maxProducts);

    if (viewedProductIds.length === 0) {
      // Hide section if no recently viewed products
      this.style.display = 'none';
      return;
    }

    try {
      // Fetch all products
      const response = await fetch('/products.json?limit=250');
      const data = await response.json();

      // Filter to only recently viewed products
      const recentProducts = viewedProductIds
        .map(id => data.products.find(p => p.id.toString() === id))
        .filter(Boolean)
        .slice(0, maxProducts);

      if (recentProducts.length === 0) {
        this.style.display = 'none';
        return;
      }

      // Render products
      this.#renderProducts(recentProducts);
    } catch (error) {
      console.error('Error loading recently viewed products:', error);
      this.style.display = 'none';
    }
  }

  /**
   * Render product cards
   * @param {Array} products
   */
  #renderProducts(products) {
    const productsContainer = this.querySelector('.pdp-related__products');
    if (!productsContainer) return;

    // Clear loading skeleton
    productsContainer.innerHTML = '';

    // Render each product
    products.forEach(product => {
      const productCard = this.#createProductCard(product);
      productsContainer.appendChild(productCard);
    });
  }

  /**
   * Create a product card element
   * @param {Object} product
   * @returns {HTMLElement}
   */
  #createProductCard(product) {
    const card = document.createElement('a');
    card.href = `/products/${product.handle}`;
    card.className = 'pdp-related__product-card';

    const firstVariant = product.variants[0];
    const price = Math.floor(parseFloat(firstVariant.price));
    const imageUrl = product.images?.[0]?.src || product.featured_image || '';

    card.innerHTML = `
      <div class="pdp-related__product-image-wrapper">
        ${imageUrl ? `
          <img
            class="pdp-related__product-image"
            src="${imageUrl}"
            alt="${product.title}"
            loading="lazy"
          />
        ` : ''}
      </div>
      <div class="pdp-related__product-info">
        <h3 class="pdp-related__product-title">${product.title}</h3>
        <p class="pdp-related__product-price">$${price}</p>
      </div>
    `;

    return card;
  }
}

if (!customElements.get('figma-recently-viewed')) {
  customElements.define('figma-recently-viewed', FigmaRecentlyViewed);
}
